import axios from "axios";
import {getHeader, getSliderAds} from "./../../config";
import {types} from "../types/globalTypes";
import {homeSliderTypes} from "../types/homeSliderTypes";


export const getHomeSliders = () => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.get(getSliderAds, {headers: getHeader()}).then(res => {
            if (res.data.Error.code === 20) {
                dispatch({
                    type: homeSliderTypes.GET_HOME_SLIDERS,
                    payload: res.data.Response
                })
            }
        }).catch(err => {
            //console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};
export const clearHomeIntro = () => {
    return (dispatch) => {
        dispatch({
            type: homeSliderTypes.CLEAR_HOME_INTRO,
            payload: []
        });
    }
};
